import { Button } from '@navent-jobs/ui-kit/components/button'
import styled from 'styled-components'

const styledCardDefault = styled('div')`
  background: ${({ theme }) => theme.colors.grey0};
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
`

export const CardEstadisticas = styled(styledCardDefault)``

export const InfoExpe = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 13px;
  align-items: center;
`

export const VerEstadisticasButton = styled(Button)`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding: 0;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;
`

export const TitleRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
